import axios from "axios"
export const getHomeData = async () => {
  try { 
    const {data} = await axios.get(`${process.env.REACT_APP_HOME_PAGE_API}/frontend/home-page-content`);
    if(data?.success){
        return data?.data;
    }
    return {};
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to fetch home data");
  }
};

